import RollerSkateWinner from './assests/RollerSkateWinner.png'
import KickBoxing from './assests/kick_boxing.jpg'
import Football from './assests/Football.jpg'
import RunnerUp from './assests/RunnerUp.jpg'
import TeacherAward from './assests/TeacherAward.png'
import Award from './assests/award.jpg'
export const images = [
    {
        description: "Winners of Roller Skating Competition at Thane District Rural Games Championship 2022-23",
        img: RollerSkateWinner
    },
    {
        description: "Master Sachin Saroj Won Gold Medal in Kick Boxing at State level 2022",
        img: KickBoxing
    },
    {
        description: "Master Anas Ali (XII) Won Man of the Match Award in Inter-College Football Competition",
        img: Football
    },
    {
        description: "Runner up team of Tug of war in Sobo festival Mumbai",
        img: RunnerUp
    },
    {
        description: "Master Pritesh of XI-B was awarded as the BEST CADET for the year 2016-2017. ",
        img: Award
    }
]
export const achievements = [
    {
        description: "Mr. Janardhan Salian (Music Teacher) Won First Prize in Singing Competition 2022",
        img: TeacherAward
    },
    {
        description: "Winners of Roller Skating Competition at Thane District Rural Games Championship 2022-23",
        img: RollerSkateWinner
    },

    {
        description: "Master Anas Ali (XII) Won Man of the Match Award in Inter-College Football Competition",
        img: Football
    },
    {
        description: "Runner up team of Tug of war in Sobo festival Mumbai",
        img: RunnerUp
    },
    {
        description: "Master Pritesh of XI-B was awarded as the BEST CADET for the year 2016-2017. ",
        img: Award
    }
]